import React from 'react';
import PropTypes from 'prop-types';

const VARIANT_STYLES = {
  red: {
    background: '#dc2626',
    color: '#fff',
    border: 'none',
  },
  black: {
    background: '#000',
    color: '#fff',
    border: 'none',
  },
};

const StatusPill = ({
  text = 'Priority',
  width = '100%',
  height = '5rem',
  variant = 'red',
  style = {},
}) => {
  const variantStyle = VARIANT_STYLES[variant] || VARIANT_STYLES.red;
  return (
    <div
      style={{
        padding: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '2rem',
        borderRadius: '12px',
        maxWidth: '200px',
        width,
        height,
        ...variantStyle,
        ...style,
      }}
    >
      <p
        style={{
          fontWeight: 'bold',
          textAlign: 'center',
          margin: 0,
          color: variantStyle.color,
        }}
      >
        {text}
      </p>
    </div>
  );
};

StatusPill.propTypes = {
  text: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  variant: PropTypes.oneOf(['red', 'black']),
  style: PropTypes.object,
};

export default StatusPill;

StatusPill.defaultProps = {
  text: 'Priority',
  width: '100%',
  height: '5rem',
  variant: 'red',
  style: {},
};
